import React, { useState } from 'react';
import Greeting from './Greeting';
import UserProfile from './UserProfile';
import UserProfileCard from './UserProfileCard';
import TaskItem from './TaskItem';
import TaskList from './TaskList';
import ShoppingCart from './ShoppingCart';

function App() {
	const user = {
		name: "Alice Wonderland",
		email: "alice@example.com",
		imageUrl: "http://example.com/alice.jpg"
};	
	const handleEdit = () => {
		// Implementation for toggling edit mode could go here
		console.log("Edit mode activated");
	};
	return(
		<div>
			<UserProfile user={user} onEdit={handleEdit} />;
			<Greeting username="Alice" />
			<UserProfileCard user={user} onEdit={handleEdit} />;
			<TaskItem />
			<TaskList />
			<ShoppingCart />
		</div>
	) 
}

export default App